/* Saukhya V2 — AJAX cart, toast, and scroll reveal */
(function () {
  'use strict';

  window.SaukhyaV2 = window.SaukhyaV2 || {};

  function toast(msg, dur) {
    dur = dur || 3000;
    var t = document.getElementById('sv2-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'sv2-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      t.style.cssText = [
        'position:fixed;bottom:84px;left:50%;',
        'transform:translateX(-50%) translateY(20px);',
        'background:#2F4F3E;color:#F8F5EF;',
        'padding:11px 22px;font-family:Inter,Georgia,sans-serif;font-size:.8rem;',
        'z-index:9999;opacity:0;pointer-events:none;',
        'transition:opacity .3s,transform .3s;',
        'white-space:nowrap;border-radius:2px;'
      ].join('');
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.style.opacity = '1';
    t.style.transform = 'translateX(-50%) translateY(0)';
    clearTimeout(t._st);
    t._st = setTimeout(function () {
      t.style.opacity = '0';
      t.style.transform = 'translateX(-50%) translateY(20px)';
    }, dur);
  }

  function addToCart(variantId, qty, btn, name) {
    var orig = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) {
        toast('Could not add to cart. Please try again.');
        if (btn) { btn.textContent = orig; btn.disabled = false; }
        return;
      }
      if (btn) {
        btn.textContent = 'Added ✓';
        btn.classList.add('added');
        setTimeout(function () {
          btn.textContent = orig;
          btn.classList.remove('added');
          btn.disabled = false;
        }, 2200);
      }
      toast((name || 'Item') + ' added to your ritual bag 🌿');
      if (window.SaukhyaCart && window.SaukhyaCart.updateCount) {
        window.SaukhyaCart.updateCount();
      }
    })
    .catch(function () {
      toast('Something went wrong. Please try again.');
      if (btn) { btn.textContent = orig; btn.disabled = false; }
    });
  }

  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.07, rootMargin: '0px 0px -32px 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  window.SaukhyaV2.addToCart = addToCart;
  window.SaukhyaV2.toast = toast;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.ing-track').forEach(function (t) {
      t.style.animationPlayState = 'paused';
    });
  }
})();
